import { For } from "solid-js";
import { Product } from "~/server/types/search";
import { OfferConstruct } from "~/server/types/brand";
import { BrandCardTelescopeLargeRnr } from "~/components/webstore_telescope/brand_card_telescope";
import { useHomeOnecardContext } from "../context/home_onecard_context";
import { OfferPill } from "./offer_pill";

export type BrandGridProps = {
  brands: Product[];
  onBrandClick: (brandKey: string) => void;
  offerConstruct?: OfferConstruct;
};

export function BrandGrid(props: BrandGridProps) {
  const { getGridCols } = useHomeOnecardContext();

  return (
    <div
      class="mx-auto grid w-full max-w-[1024px] gap-x-3 gap-y-6 px-3 sm:px-0 md:gap-x-[12px] md:gap-y-[16px]"
      classList={getGridCols()}
    >
      <For each={props.brands}>
        {(brand) => (
          <div class="relative">
            <BrandCardTelescopeLargeRnr
              imageUrl={brand.voucherProduct.sqLogoUrl}
              name={brand.voucherProduct.title}
              discountPercentage={brand.voucherProduct.discountPercentage}
              cardBackgroundColor={brand.voucherProduct.cardBackgroundColor}
              onClick={() => props.onBrandClick(brand.brandKey)}
              heroImageUrl={brand.voucherProduct.heroImageUrl}
              showHeroImage={false}
            />
            <OfferPill offerConstruct={props.offerConstruct} />
          </div>
        )}
      </For>
    </div>
  );
}
